import React, { useState } from "react";
import "../../styles/busquedaCliente.scss";
import Direccion from "../Direccion";
import NroDeMedidor from "../NroDeMedidor";
import { CGE } from "../../../../common/components/CGE";
import AlertModal from "../../../../common/components/AlertModal";
import { useModal } from "@clayui/modal";

const BusquedaPrincipal = ({ hideSearch, changeInputNumClient, inputForms, setGlobalAlert, containerSize = "md" }) => {
    const [isDirectionVisible, setIsDirectionVisible] = useState(false);
    const [isMeterNumberVisible, setIsMeterNumberVisible] = useState(false);
    const [numIdEstasSinLuz, setNumIdEstasSinLuz] = useState("");
    const [numIdPagoEnLinea, setNumIdPagoEnLinea] = useState("");
    const [visibleModalConfirm, setVisibleModalConfirm] = React.useState(false);
    const { observer, onClose } = useModal({
      onClose: () => {
        setVisibleModalConfirm(false);
      }
    });

    function showDirection() {
        if (isMeterNumberVisible) {
            setIsMeterNumberVisible(false)
            setIsDirectionVisible(true)
        } else {
            setIsDirectionVisible(true)
        }
    }

    function showMeterNumber() {
        if (isDirectionVisible) {
            setIsMeterNumberVisible(true)
            setIsDirectionVisible(false)
        } else {
            setIsMeterNumberVisible(true)
        }
    }

    function setNumIdEstasSinLuzAux(id) {
        setNumIdEstasSinLuz(id);
        setVisibleModalConfirm(true);
    }

    function setNumIdPagoEnLineaAux(id) {
        setNumIdPagoEnLinea(id);
        setVisibleModalConfirm(true);
    }
    
    return (
        <div className="cge-busqueda">
            <CGE.Panel title="Ingrese la información para la búsqueda" description="Seleccione por donde desea realizar la búsqueda">
                <CGE.PanelContainer
                    alingItensCenter={true}
                    size={containerSize}
                >
                    <div className="cge-busqueda__sides">
                        <CGE.InlineRow>
                            <CGE.InlineCol>
                                <CGE.Text
                                    labelClassname="cge-busqueda__radio"
                                    classNameOtherElement="mr-1"
                                    nameOtherElement="search"
                                    onChangeOtherElement={showDirection}
                                    typeOtherElement="radio"
                                    valueOtherElement="Direction"
                                    size="6"
                                    text="Dirección"
                                />
                            </CGE.InlineCol>
                            <CGE.InlineCol>
                                <CGE.Text
                                    labelClassname="cge-busqueda__radio"
                                    classNameOtherElement="mr-1"
                                    nameOtherElement="search"
                                    onChangeOtherElement={showMeterNumber}
                                    typeOtherElement="radio"
                                    valueOtherElement="MeterNumber"
                                    size="6"
                                    text="Nro de Medidor"
                                />
                            </CGE.InlineCol>
                        </CGE.InlineRow>
                        <CGE.Spacing type="ct" />
                        {isDirectionVisible &&
                            (
                                <Direccion
                                    hideSearch={hideSearch}
                                    changeInputNumClient={changeInputNumClient}
                                    inputForms={inputForms}
                                    setGlobalAlert={setGlobalAlert}
                                    setNumIdEstasSinLuz={setNumIdEstasSinLuzAux}
                                    setNumIdPagoEnLinea={setNumIdPagoEnLineaAux}
                                />
                            )
                        }
                        {isMeterNumberVisible &&
                            (
                                <NroDeMedidor
                                    hideSearch={hideSearch}
                                    changeInputNumClient={changeInputNumClient}
                                    inputForms={inputForms}
                                    setGlobalAlert={setGlobalAlert}
                                    setNumIdPagoEnLinea={setNumIdPagoEnLineaAux}
                                    setNumIdEstasSinLuz={setNumIdEstasSinLuzAux}
                                />
                            )
                        }
                    </div>
                </CGE.PanelContainer>
            </CGE.Panel>
            {visibleModalConfirm && (
                <AlertModal
                    titleModal="¡Confirmación!"
                    msgModal={numIdEstasSinLuz ? "<b>¿Volver para Estas Sin Luz ?</b><p>Nro Cliente: "+numIdEstasSinLuz+"</p>":"<b>¿Volver para Pago en línea ?</b><p>Nro Cliente: "+numIdPagoEnLinea+"</p>"}
                    observer={observer}
                    onClose={() => {
                    onClose();
                    }}
                    status="info"
                    funcClick={() => {
                    window.location.href =numIdEstasSinLuz ? "/web/guest/estas-sin-luz?nrcli="+numIdEstasSinLuz :"/web/guest/pago-en-linea?cuentaContrato="+numIdPagoEnLinea;
                    setVisibleModalConfirm(false)
                    }}
                    confirm={true}
                />
                )}
        </div>
    )
};

export default BusquedaPrincipal;